// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__7VTjc","spin":"Loader_spin__z+6X1"};